// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
    return new Promise(function (resolve, reject) {
        if (document.readyState === 'complete') {
            resolve(document);
        } else {
            document.addEventListener('DOMContentLoaded', function () {
                resolve(document);
            });
        }
    });
};

document.ready().then(function () {

    const mobileParentLinks = document.querySelectorAll('#nav-mobile > li.menu-item-has-children > a');
    for (const link of mobileParentLinks) {
        
        const element = document.createElement('div');
        const subElement = document.createElement('span');
        element.insertAdjacentElement('beforeend', subElement);
        
        element.classList.add('mobile-submenu-toggle');
        subElement.classList.add('fas', 'fa-chevron-down');
        
        // Put the elements inside of the parent link
        link.insertAdjacentElement('beforeend', element);
        
        subElement.addEventListener('click', (event) => {
            event.preventDefault();
            link.parentElement.classList.toggle('open');
            subElement.classList.toggle('fa-flip-vertical');
        });
    }

});